var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('title')))]),_vm._v(" "),(_setup.hasValues)?_c('VueApexCharts',{attrs:{"options":_setup.chartOptions,"series":_setup.series,"height":300}}):_c('v-alert',{attrs:{"type":"info","text":"","outlined":"","color":"info"}},[_vm._v("\n    "+_vm._s(_vm.$t('alert'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }